import {
    FreelancerContacts,
    FreelancerPageStates,
    FreelancersListItem
} from '../../typings/freelancers';
import { GdFreelancersCardStatusModerate } from '../../typings/graphql-grid';
import { SortParams } from '../../typings/grid';

export const FETCH_FREELANCERS_LIST_DATA = 'FETCH_FREELANCERS_LIST_DATA';
export type FETCH_FREELANCERS_LIST_DATA = typeof FETCH_FREELANCERS_LIST_DATA;

export const UPDATE_FREELANCERS_LIST_DATA = 'UPDATE_FREELANCERS_LIST_DATA';
export type UPDATE_FREELANCERS_LIST_DATA = typeof UPDATE_FREELANCERS_LIST_DATA;

export const UPDATE_SINGLE_FREELANCER_DATA = 'UPDATE_SINGLE_FREELANCER_DATA';
export type UPDATE_SINGLE_FREELANCER_DATA = typeof UPDATE_SINGLE_FREELANCER_DATA;

export const SET_FREELANCER_COOPERATION_STATUS =
    'SET_FREELANCER_COOPERATION_STATUS';
export type SET_FREELANCER_COOPERATION_STATUS = typeof SET_FREELANCER_COOPERATION_STATUS;

export const SORT_FREELANCERS_LIST_DATA = 'SORT_FREELANCERS_LIST_DATA';
export type SORT_FREELANCERS_LIST_DATA = typeof SORT_FREELANCERS_LIST_DATA;

export const SET_FREELANCERS_LIST_PAGE_STATUS =
    'SET_FREELANCERS_LIST_PAGE_STATUS';
export type SET_FREELANCERS_LIST_PAGE_STATUS = typeof SET_FREELANCERS_LIST_PAGE_STATUS;

export interface UpdateSingleFreelancerDataActionParams {
    statusModerate: GdFreelancersCardStatusModerate;
    about: string;
    avatarLink: string;
    contacts: FreelancerContacts;
}

export interface FetchFreelancersListDataAction {
    type: FETCH_FREELANCERS_LIST_DATA;
    login: string;
    sortParams?: SortParams;
    freelancerLogins?: string[];
}

export interface UpdateFreelancersListDataAction {
    type: UPDATE_FREELANCERS_LIST_DATA;
    payload: FreelancersListItem[];
    sortParams?: SortParams;
}

export interface UpdateSingleFreelancerDataAction {
    type: UPDATE_SINGLE_FREELANCER_DATA;
    freelancerId: string;
    payload: UpdateSingleFreelancerDataActionParams;
}

export interface SetFreelancerCooperationStatusAction {
    type: SET_FREELANCER_COOPERATION_STATUS;
    freelancerId: string;
}

export interface SortFreelancersListDataAction {
    type: SORT_FREELANCERS_LIST_DATA;
    sortParams: SortParams;
}

export interface SetFreelancersListPageStatusAction {
    type: SET_FREELANCERS_LIST_PAGE_STATUS;
    status: FreelancerPageStates;
}

export function fetchFreelancersListData(
    login: string,
    sortParams?: SortParams,
    freelancerLogins?: string[]
): FetchFreelancersListDataAction {
    return {
        type: FETCH_FREELANCERS_LIST_DATA,
        sortParams,
        login,
        freelancerLogins
    };
}

export function updateFreelancersListData(
    payload: FreelancersListItem[],
    sortParams?: SortParams
): UpdateFreelancersListDataAction {
    return {
        type: UPDATE_FREELANCERS_LIST_DATA,
        payload,
        sortParams
    };
}

export function updateSingleFreelancerData(
    freelancerId: string,
    payload: UpdateSingleFreelancerDataActionParams
): UpdateSingleFreelancerDataAction {
    return {
        type: UPDATE_SINGLE_FREELANCER_DATA,
        freelancerId,
        payload
    };
}

export function setFreelancerCooperationStatus(
    freelancerId: string
): SetFreelancerCooperationStatusAction {
    return {
        type: SET_FREELANCER_COOPERATION_STATUS,
        freelancerId
    };
}

export function sortFreelancersListData(
    sortParams: SortParams
): SortFreelancersListDataAction {
    return {
        type: SORT_FREELANCERS_LIST_DATA,
        sortParams
    };
}

export function setFreelancersListPageStatus(
    status: FreelancerPageStates
): SetFreelancersListPageStatusAction {
    return {
        type: SET_FREELANCERS_LIST_PAGE_STATUS,
        status
    };
}

export type FreelancersListAction =
    | FetchFreelancersListDataAction
    | UpdateFreelancersListDataAction
    | UpdateSingleFreelancerDataAction
    | SetFreelancerCooperationStatusAction
    | SortFreelancersListDataAction
    | SetFreelancersListPageStatusAction;
